




import storage from '@/services/storage';
import config from '@/helpers/config';

const configuration = config();
const BASE_PATH = configuration.MYTOOLS;

export default {
    props: ['slug'],
    methods: {
        load(this: any) {
            const data = {
                url: this.createUrl(),
                storage: storage.getUser(),
            };

            this.$refs.mainFrame.contentWindow.postMessage(JSON.stringify(data), '*');
        },
        createUrl(this: any) {
            return `${BASE_PATH}/${this.$route.name}?inFrame=true`;
        },
    },
};
